import React from 'react';
import { Tab, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TabsContainer, StyledTabs } from './UserDetailStyled';
import useUserAuth from '../../../utils/useUserAuth';

const TAB_CONFIG = [
  { value: 'one', labelKey: '회원정보' },
  { value: 'three', labelKey: '상품 상세' },
  { value: 'two', labelKey: '출결/예약' },
  { value: 'four', labelKey: '결제 내역', authKey: 'MEMBER_PAYMENT_VIEW' },
  { value: 'six', labelKey: '상담 내역', authKey: 'MEMBER_CONSULTATION' },
  { value: 'eight', labelKey: '변경 내역' },
  { value: 'five', labelKey: '양도/양수', authKey: 'MEMBER_TRANSFER' },
  { value: 'ten', labelKey: '포인트' },
  { value: 'nine', labelKey: '계약서' },
];

// 라이트버전(ROLE_GUEST)에서 클릭 시 안내 오버레이로 차단되는 탭 (양도/양수, 포인트)
const LITE_BLOCKED_TAB_VALUES = ['five', 'ten'];

const UserDetailTabs = ({ selectedTab, onTabChange, isGuestUser = false, onLiteBlockedTabClick }) => {
  const { t } = useTranslation();
  const canPaymentView = useUserAuth('MEMBER_PAYMENT_VIEW');
  const canConsultation = useUserAuth('MEMBER_CONSULTATION');
  const canTransfer = useUserAuth('MEMBER_TRANSFER');

  const authMap = {
    MEMBER_PAYMENT_VIEW: canPaymentView,
    MEMBER_CONSULTATION: canConsultation,
    MEMBER_TRANSFER: canTransfer,
  };

  const isLiteBlockedTab = value => isGuestUser && LITE_BLOCKED_TAB_VALUES.includes(value);

  const handleTabChange = (event, newValue) => {
    // 라이트버전 차단 탭: 이동하지 않고 안내 오버레이만 표시
    if (isLiteBlockedTab(newValue)) {
      onLiteBlockedTabClick?.();
      return;
    }
    const tabConfig = TAB_CONFIG.find(tab => tab.value === newValue);
    if (tabConfig?.authKey && !authMap[tabConfig.authKey]) return;
    onTabChange(event, newValue);
  };

  return (
    <TabsContainer>
      <StyledTabs
        value={selectedTab}
        onChange={handleTabChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="user detail tabs">
        {TAB_CONFIG.map(tab => {
          // 라이트버전 차단 탭은 잠금 스타일 대신 정상 모양 유지 (클릭 시 오버레이로 안내)
          const hasAuth = !tab.authKey || authMap[tab.authKey] || isLiteBlockedTab(tab.value);
          const tabElement = (
            <Tab
              key={tab.value}
              value={tab.value}
              label={t(tab.labelKey)}
              sx={!hasAuth ? { color: '#ccc !important', opacity: '1 !important' } : {}}
            />
          );
          if (!hasAuth) {
            return (
              <Tooltip key={tab.value} title="권한이 없습니다" arrow>
                {tabElement}
              </Tooltip>
            );
          }
          return tabElement;
        })}
      </StyledTabs>
    </TabsContainer>
  );
};

export default UserDetailTabs;
